<template>
    <div class="course-container">
        <!--详情-->
        <div class="lesson-container" v-show="this.showMode==='view'">
            <!--信息-->
            <div class="left-container">
                <div class="top-title">听评课详情</div>
                <div class="info-column-container">
                    <div class="flex-item column-title">基本信息</div>
                    <div class="flex-item column-status" v-if="lessonInfo.status===1">初始</div>
                    <div class="flex-item column-status" v-if="lessonInfo.status===2">进行中</div>
                    <div class="flex-item column-status-fb" v-if="lessonInfo.status===3">已结束</div>
                    <div class="flex-item column-btn">
                        <div class="btn"
                             v-if="this.isShow&&lessonInfo.status!==3&&(this.role==='1'||this.role==='2'||this.userId===lessonInfo.createUser)"
                             @click="editLesson">
                            编辑
                        </div>
                        <div class="btn"
                             v-if="this.isShow&&lessonInfo.status===2&&(this.role==='1'||this.role==='2'||this.userId===lessonInfo.createUser)"
                             @click="handleStop">
                            停止评课
                        </div>
                        <div class="btn"
                             v-if="this.isShow&&lessonInfo.status!==1&&lessonInfo.role===3"
                             @click="handleSummary">
                            评课总结
                        </div>
                        <el-popover placement="bottom-start" trigger="hover" :width="'auto'">
                            <div>
                                <div v-if="lessonInfo.scaleList && lessonInfo.scaleList.length !== 0">
                                    <div class="scale-item"
                                         @click="handleComplete(item)" :title="item.title"
                                         v-for="(item, index) in lessonInfo.scaleList">
                                         <div v-if="item.isSub===0" style="color: #0d55a4">请填写-</div>
                                         <div v-if="item.isSub===1" >已提交-</div>
                                         <div :style="item.isSub===1?'':'color: #0d55a4'">{{ item.title }}</div>
                                    </div>
                                </div>
                            </div>
                            <template #reference>
                                <div class="btn"
                                     v-if="lessonInfo.scaleList && lessonInfo.scaleList.length !== 0
                                && (lessonInfo.role===3||lessonInfo.role===1||lessonInfo.role===0)&&
                                    lessonInfo.rateEndTime>this.currentTime">
                                    填写量表
                                </div>
                            </template>
                        </el-popover>
                        <div class="btn"
                             v-if="this.isShow&& !lessonInfo.lessonVideoUrl&&lessonInfo.status===3&&lessonInfo.role===0"
                             @click="isShowLessonVideo=!isShowLessonVideo">
                            上传实录
                        </div>

                    </div>
                </div>
                <div class="base-info-container">
                    <div class="part-container">
                        <div class="part1-l">
                            <div class="info-lesson-title">
                                [听评课]{{lessonInfo.title}}
                            </div>
                            <div class="info-item">
                                <div>市区县：{{lessonInfo.countyName}}</div>
                                <div>学校名称：{{lessonInfo.schoolName}}</div>
                            </div>
                            <div class="info-item">
                                <div>学科信息：{{lessonInfo.periodName}}、{{lessonInfo.gradeName}}、{{lessonInfo.subjectName}}</div>
                                <div>听课性质：
                                    <span v-if="lessonInfo.lessonNature === '1'">普通</span>
                                    <span v-if="lessonInfo.lessonNature === '2'">名师工作室</span>
                                    <span v-if="lessonInfo.lessonNature === '3'">名校长工作室</span>
                                    <span v-if="lessonInfo.lessonNature === '4'">群组任务</span>
                                </div>
                            </div>
                            <div class="info-item">
                                <div>听课类型：{{lessonInfo.type===0?'推门':'线上'}}</div>
                            </div>
                            <div class="info-item">
                                <div>授课老师：{{lessonInfo.lectureTeacherName}}</div>
                                <div>指导专家：{{lessonInfo.guideExpertTxt?lessonInfo.guideExpertTxt:'暂无'}}</div>
                            </div>
                            <div class="info-item-auto">
                                听课老师：{{lessonInfo.listenTeacherTxt}}
                            </div>
                            <div class="info-item-auto">
                                评课老师：{{lessonInfo.rateTeacherTxt}}
                            </div>
                        </div>
                        <div class="part1-r">
                            <div class="base-info-cover">
                                <img class="img-100"  :src="lessonInfo.coverUrl" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="part-container">
                        <div class="part2-l">
                            <div class="info-item">
                                听课时段：{{ timestampToTime(lessonInfo.beginTime)}}至{{ timestampToTime(lessonInfo.endTime)}}
                            </div>
                            <div class="info-item">
                                评课截止：{{ timestampToTime(lessonInfo.rateEndTime)}}
                            </div>
                            <div class="info-item-auto" v-if="lessonInfo.type === 0">
                                听课地址：{{lessonInfo.address}}
                            </div>
                            <div class="info-item" v-if="lessonInfo.type === 1||lessonInfo.type === 2">
                                听课地址：<div @click="beginLesson" type="primary" class="eva-btn">去听课</div>
                            </div>
                        </div>
                        <div class="part2-r" v-if="lessonInfo.status!==3">
                            <div class="code-item">
                                <div class="code-title">
                                    听课邀请码
                                </div>
                                <div class="code-img" @click="handleTkDownload">
                                    <el-tooltip
                                      class="box-item"
                                      effect="dark"
                                      content="点击下载二维码"
                                      placement="bottom">
                                        <vueQr ref="tkcode" :text="qrCode.shareTkUrl"
                                               :size="qrCode.size"
                                               :margin="qrCode.margin"/>
                                    </el-tooltip>

                                </div>
                            </div>
                            <div class="code-item">
                                <div class="code-title">
                                    评课邀请码
                                </div>
                                <div class="code-img" @click="handlePkDownload">
                                    <el-tooltip
                                      class="box-item"
                                      effect="dark"
                                      content="点击下载二维码"
                                      placement="bottom">
                                        <vueQr ref="pkcode" :text="qrCode.sharePkUrl"
                                               :size="qrCode.size"
                                               :margin="qrCode.margin"/>
                                    </el-tooltip>

                                </div>
                            </div>
                            <div class="code-item">
                                <div class="code-title">
                                    专家邀请码
                                </div>
                                <div class="code-img" @click="handleZjDownload">
                                    <el-tooltip
                                      class="box-item"
                                      effect="dark"
                                      content="点击下载二维码"
                                      placement="bottom">
                                        <vueQr ref="zjcode" :text="qrCode.shareZjUrl"
                                               :size="qrCode.size"
                                               :margin="qrCode.margin"/>
                                    </el-tooltip>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="part-container" v-if="lessonInfo.type === 0">
                        <div class="map-container">
                            <aMap isDetail v-if="isShowMap" ref="zdyMap"
                                  @getGeocoder="getGeocoder"
                                  :oldCenter="oldCenter"
                                  :isShowAMap="true">
                            </aMap>
                        </div>

                    </div>
                </div>
                <!--听课量表 -->
                <div class="info-column-container" v-if="lessonInfo.scaleList&&lessonInfo.scaleList.length>0">
                    <div class="column-title">听课量表</div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in lessonInfo.scaleList" :key="item">
                        <div class="file-title" @click="handleComplete(item)">{{item.title}}</div>
                        <div class="file-view" @click="handleComplete(item)">
                            <svg t="1742436699597" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2755" width="22" height="22"><path d="M938.666667 553.92V768c0 64.8-52.533333 117.333333-117.333334 117.333333H202.666667c-64.8 0-117.333333-52.533333-117.333334-117.333333V256c0-64.8 52.533333-117.333333 117.333334-117.333333h618.666666c64.8 0 117.333333 52.533333 117.333334 117.333333v297.92z m-64-74.624V256a53.333333 53.333333 0 0 0-53.333334-53.333333H202.666667a53.333333 53.333333 0 0 0-53.333334 53.333333v344.48A290.090667 290.090667 0 0 1 192 597.333333a286.88 286.88 0 0 1 183.296 65.845334C427.029333 528.384 556.906667 437.333333 704 437.333333c65.706667 0 126.997333 16.778667 170.666667 41.962667z m0 82.24c-5.333333-8.32-21.130667-21.653333-43.648-32.917333C796.768 511.488 753.045333 501.333333 704 501.333333c-121.770667 0-229.130667 76.266667-270.432 188.693334-2.730667 7.445333-7.402667 20.32-13.994667 38.581333-7.68 21.301333-34.453333 28.106667-51.370666 13.056-16.437333-14.634667-28.554667-25.066667-36.138667-31.146667A222.890667 222.890667 0 0 0 192 661.333333c-14.464 0-28.725333 1.365333-42.666667 4.053334V768a53.333333 53.333333 0 0 0 53.333334 53.333333h618.666666a53.333333 53.333333 0 0 0 53.333334-53.333333V561.525333zM320 480a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m0-64a32 32 0 1 0 0-64 32 32 0 0 0 0 64z" fill="#0d55a4" p-id="2756"></path></svg>
                        </div>
                        <div class="file-view" @click="handleRateScale(item)">
                            <svg t="1742437967417" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18483" width="20" height="18"><path d="M876.08888889 2.27555555H147.91111111c-80.09955555 0-145.63555555 65.536-145.63555556 145.63555556v728.17777778c0 80.09955555 65.536 145.63555555 145.63555556 145.63555556h728.17777778c80.09955555 0 145.63555555-65.536 145.63555556-145.63555556V147.91111111c0-80.09955555-65.536-145.63555555-145.63555556-145.63555556zM293.54666667 839.68c0 20.02488889-16.384 36.40888889-36.40888889 36.40888889h-72.81777778c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V475.59111111c0-20.02488889 16.384-36.40888889 36.40888889-36.40888889h72.81777778c20.02488889 0 36.40888889 16.384 36.40888889 36.40888889v364.08888889z m291.95377778 0c0 20.02488889-16.384 36.40888889-36.4088889 36.40888889h-72.81777777c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V329.95555555c0-20.02488889 16.384-36.40888889 36.40888889-36.40888888h72.81777777c20.02488889 0 36.40888889 16.384 36.4088889 36.40888888v509.72444445z m290.58844444 0c0 20.02488889-16.384 36.40888889-36.40888889 36.40888889h-72.81777778c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V402.77333333c0-20.02488889 16.384-36.40888889 36.40888889-36.40888888h72.81777778c20.02488889 0 36.40888889 16.384 36.40888889 36.40888888v436.90666667z" fill="#0d55a4" p-id="18484"></path></svg>
                        </div>
                    </div>
                </div>

                <!--备课文件 -->
                <div class="info-column-container" style="margin-top: 10px;" v-if="lessonInfo.lessonFileList&&lessonInfo.lessonFileList.length>0">
                    <div class="column-title">备课文件</div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in lessonInfo.lessonFileList" :key="item">
                        <div class="file-title">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                        </div>
                    </div>
                </div>

                <!--评估报告 -->
                <div class="info-column-container" style="margin-top: 10px;" v-if="(this.role==1||this.role==2||lessonInfo.role==0)&&lessonInfo.fxbgFileList&&lessonInfo.fxbgFileList.length>0">
                    <div class="column-title">AI评估报告</div>
                </div>
                <div class="file-list" v-if="this.role==1||this.role==2||lessonInfo.role==0" >
                    <div class="file-item" v-for="item in lessonInfo.fxbgFileList" :key="item">
                        <div class="file-title">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                        </div>
                    </div>
                </div>

                <!--专家报告 -->
                <div class="info-column-container" style="margin-top: 10px;" v-if="(this.role==1||this.role==2||lessonInfo.role==0)&&lessonInfo.expertFileList&&lessonInfo.expertFileList.length>0">
                    <div class="column-title">专家报告</div>
                </div>
                <div class="file-list" v-if="this.role==1||this.role==2||lessonInfo.role==0" >
                    <div class="file-item" v-for="item in lessonInfo.expertFileList" :key="item">
                        <div class="file-title">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                        </div>
                    </div>
                </div>

                <!--课堂实录 -->
                <div class="info-column-container" style="margin-top: 10px;"
                     v-if="(this.role==1||this.role==2||lessonInfo.role==0)&&lessonInfo.lessonVideoUrl">
                    <div class="column-title">课堂实录</div>
                </div>
                <div class="file-list" v-if="(this.role==1||this.role==2||lessonInfo.role==0)&&lessonInfo.lessonVideoUrl" >
                    <div class="file-item">
                        <div class="file-title">课堂实录</div>
                        <div class="file-view">

                        </div>
                        <div class="file-view">
                            <svg t="1761811735057" @click="viewVideo" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5234" width="24" height="24"><path d="M772.7 217.7a32.2 32.1 0 1 0 64.4 0 32.2 32.1 0 1 0-64.4 0Z" fill="#0d55a4" p-id="5235"></path><path d="M415.8 679.9c5.9 0 11.5-1.6 16.2-4.5l231.1-134.6c10.9-5.2 18.5-16.3 18.5-29.2 0-11.9-6.4-22.3-16-27.8L439.7 352.2c-5.8-6.7-14.4-10.9-23.9-10.9-17.6 0-31.8 14.4-31.8 32.1 0 0.6 0 1.2 0.1 1.8l-0.4 0.2 0.5 269c-0.1 1.1-0.2 2.2-0.2 3.4 0 17.7 14.3 32.1 31.8 32.1z" fill="#0d55a4" p-id="5236"></path><path d="M909.8 306.6c-5.4-10.5-16.3-17.8-28.9-17.8-17.8 0-32.2 14.4-32.2 32.1 0 6 1.7 11.7 4.6 16.5l-0.1 0.1c26.9 52.4 42.1 111.8 42.1 174.7 0 211.6-171.6 383.2-383.2 383.2S128.8 723.8 128.8 512.2 300.4 129.1 512 129.1c62.5 0 121.5 15 173.6 41.5l0.2-0.4c4.6 2.6 10 4.1 15.7 4.1 17.8 0 32.2-14.4 32.2-32.1 0-13.1-7.9-24.4-19.3-29.4C653.6 81.9 584.9 64.5 512 64.5 264.7 64.5 64.3 265 64.3 512.2S264.7 959.9 512 959.9s447.7-200.4 447.7-447.7c0-74.1-18-144-49.9-205.6z" fill="#0d55a4" p-id="5237"></path></svg>
                        </div>
                    </div>
                </div>

                <!--附件内容 -->
                <div class="info-column-container" style="margin-top: 10px;" v-if="lessonInfo.fileList&&lessonInfo.fileList.length>0">
                    <div class="column-title">附件内容</div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in lessonInfo.fileList" :key="item">
                        <div class="file-title">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                        </div>
                    </div>
                </div>

            </div>
            <!--讨论区-->
            <div class="right-container">
                <div class="discuss-title-box">
                    讨论区
                </div>
                <div class="discuss-sub-box" v-if="isShowDiscuss">
                    <div class="discuss-info">
                        <el-input
                          type="textarea"
                          @focus="focusInput"
                          resize="none"
                          placeholder="请输入讨论内容"
                          v-model="discussWordContent"
                          autofocus
                          class="discuss-info-input"
                        >
                        </el-input>
                    </div>
                    <div class="discuss-btn-box">
                        <div class="limit">
                            <el-upload class="discuss-uploader"
                                       :action="serviceUrl+'/businessservice/evaluation/discussAnnex'"
                                       :show-file-list="false"
                                       :on-success="handleUploadFileSuccess"
                                       :headers="{ token }"
                                       accept=".doc,.docx,.ppt,.pptx,.pdf"
                                       :before-upload="beforeFileUpload">

                                <img class="icon-upload-img" alt="上传附件" src="../../assets/icon/img/upload_file1.png">
                            </el-upload>
                        </div>

                        <div class="limit">
                            <el-upload class="discuss-uploader"
                                       :action="serviceUrl+'/businessservice/evaluation/discussAnnex'"
                                       :show-file-list="false"
                                       :on-success="handleUploadImageSuccess"
                                       :headers="{ token }"
                                       accept=".png,.jpeg,.jpg"
                                       :before-upload="beforeImageUpload">
                                <img class="icon-upload-img" alt="上传图片" src="../../assets/icon/img/upload_img1.png">
                            </el-upload>
                        </div>
                        <el-button type="primary" style="margin-left: 120px;" round @click="submitDiscuss">
                            发表
                        </el-button>
                    </div>
                </div>
                <el-scrollbar class="discuss-show-box">
                    <div class="discuss-one" v-for="item in discussList">
                        <div class="discuss-user-avatar">
                            <img class="discuss-user-avatar-img" alt="无" @error="onImageError" :src="item.avatar">
                        </div>
                        <div class="discuss-user-content">
                            <div class="user-info">
                                <div class="flex-item user-true-name">{{item.createUserName}}</div>
                                <div class="flex-item user-role">
                                    <div class="role2" v-show="item.roleType===0">授课人</div>
                                    <div class="role2" v-show="item.roleType===1">评课人</div>
                                    <div class="role2" v-show="item.roleType===2">听课人</div>
                                    <div class="role2" v-show="item.roleType===3">评课组长</div>
                                    <div class="role1" v-show="item.roleType===4">专家</div>
                                </div>
                                <div class="flex-item content-time">{{timestampToTime(item.createTime)}}</div>
                            </div>
                            <div class="content-info" v-if="item.discussType===1">
                                {{item.content}}
                            </div>
                            <div class="img-info" v-if="item.discussType===2">
                                <el-image alt="" :src="item.imgContent"
                                          :preview-src-list="item.imgList" ></el-image>
                            </div>
                            <div class="audio-info" v-show="item.discussType===3">
                                <audio controls controlslist="nodownload noplaybackrate" ref="audio">
                                    <source type="audio/wav" :src="item.audioContent" />
                                </audio>
                            </div>
                            <div class="file-info" v-if="item.discussType===4">
                                <div class="file-box">
                                    <div class="file-icon">
                                        <el-image @click="handleFIleStatus(item.file.status)" class="icon-image" v-if="comStr('pdf',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-pdf@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleFIleStatus(item.file.status)" class="icon-image" v-if="comStr('doc',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-doc@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleFIleStatus(item.file.status)" class="icon-image" v-if="comStr('ppt',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-ppt@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleUnKnow" class="icon-image" v-if="!comStr('ppt',item.file.fileType)&&!comStr('doc',item.file.fileType)&&!comStr('pdf',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-unknown@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                    </div>
                                    <div class="file-detail">
                                        <div class="name-box" @click.stop="handleDownload(item.file.fileUrl,item.file.fileName)">{{item.file.fileName}}</div>
                                        <div class="size-box">
                                            <div class="size-num">{{item.file.fileSize}}</div>
                                            <div class="file-view">
                                                <img alt="" src="@/assets/icon/img/download.png" @click.stop="handleDownload(item.file.fileUrl,item.file.fileName)">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="discussList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                </el-scrollbar>

            </div>
        </div>

        <!--编辑-->
        <div class="lesson-edit-container" v-show="this.showMode==='edit'">
            <div class="top-title">编辑听评课</div>
            <el-form ref="form" :model="lessonInfo" :rules="rules" label-width="110px">
                <div class="info-column-container">
                    <div class="column-title">基本信息</div>
                </div>
                <el-row class="mt10">
                    <el-col :span="8">
                        <el-form-item label="市区县" prop="countyId">
                            <el-select v-model="lessonInfo.countyId" placeholder="请选择市区县" @change="changeCounty">
                                <el-option v-for="item in countyList" :key="item.orgId" :label="item.orgName"
                                           :value="item.orgId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="学校" prop="schoolId">
                            <el-select v-model="lessonInfo.schoolId" placeholder="请选择学校">
                                <el-option v-for="item in schoolList" :key="item.orgId" :label="item.orgName"
                                           :value="item.orgId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="学段" prop="periodKey">
                            <el-select @change="changePeriod" v-model="lessonInfo.periodKey" placeholder="请选择学段">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="年级" prop="gradeKey">
                            <el-select @change="changeGrade" v-model="lessonInfo.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="学科" prop="subjectKey">
                            <el-select v-model="lessonInfo.subjectKey" placeholder="请选择学科">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="15">
                        <!--课程标题-->
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="课程标题" prop="title">
                                    <el-input v-model="lessonInfo.title" placeholder="请输入课程标题"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-icon @click="queryDirectory" class="cursor" :size="24" style="margin-top: 3px;margin-left: 7px;">
                                    <Notebook></Notebook>
                                </el-icon>
                            </el-col>
                        </el-row>
                        <!--听评课性质-->
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="听评课性质" prop="lessonNature">
                                    <el-select @change="changeLessonNature" style="width: 100%;" v-model="lessonInfo.lessonNature"
                                               placeholder="请选择备课性质">
                                        <el-option v-for="item in natureList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--听评课关联群组或工作室-->
                        <el-row v-if="lessonInfo.lessonNature != '1'">
                            <el-col :span="12">
                                <el-form-item :label="lessonInfo.lessonNature == 4 ? '群组' : '工作室'" prop="groupId">
                                    <el-select @change="changeQun" style="width: 100%;" v-model="lessonInfo.groupId"
                                               placeholder="请选择工作室/群组">
                                        <el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName"
                                                   :value="item.groupId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--听评课类型-->
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="类型" prop="type">
                                    <el-radio-group v-model="lessonInfo.type">
                                        <el-radio :label="0">推门</el-radio>
                                        <el-radio :label="1">线上</el-radio>
                                        <el-radio :label="2">本地视频</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--直播地址或视频地址-->
                        <el-row>
                            <el-col :span="20" v-if="lessonInfo.type === 1">
                                <el-form-item label="听课地址" prop="address">
                                    <el-input v-model="lessonInfo.address" placeholder="请输入线上地址" maxlength="256">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20" v-if="lessonInfo.type === 2||lessonInfo.type === 3">
                                <el-form-item label="听课地址" prop="address">
                                    <el-input v-model="lessonInfo.address" placeholder="请输入视频网址或上传本地视频" maxlength="256">
                                        <template #append>
                                            <el-button @click="showUpload">上传视频</el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="任务时段" prop="formTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" @change="startDateConfirm" :disabled-date="disabledDate"
                                                        style="width: 100%;" v-model="lessonInfo.beginTime" type="datetime" placeholder="开始时间"
                                                        value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" @change="endDateConfirm"
                                                        style="width: 100%;" v-model="lessonInfo.endTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="评课截止时间" prop="rateEndTime">
                                    <el-date-picker format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" v-model="lessonInfo.rateEndTime"
                                                    type="datetime" placeholder="请选择评课截止时间" value-format="x" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--协同备课文件-->
                        <el-row>
                            <el-col :span="20" >
                                <el-form-item label="协同备课文件" prop="lessonFileList">
                                    <selectLessonFile :showTitle="'选择备课文件'"
                                                      :prepareLessonId="lessonInfo.prepareLessonId"
                                                      @lessonTeamUser="lessonTeamUser"
                                                      ref="lessonFileList" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="上传附件" prop="">
                                    <el-upload v-model:file-list="fileList" class="upload-demo" :on-remove="handleRemove"
                                               :action="serviceUrl+'/businessservice/evaluation/uploadFile'"
                                               :on-change="handleJAChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                               :before-upload="beforeJAUpload">
                                        <el-button type="primary">点击上传</el-button>
                                        <template #tip>
                                            <div class="el-upload__tip">
                                                只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                            </div>
                                        </template>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="授课教师" prop="lectureTeacher">
                                    <choosePeople v-show="role !== 6" :showTitle="'选择人员'" @gxDisable="gxDisable" :radio="true"
                                                  ref="lectureTeacher" />
                                    <div v-show="role === 6">{{ lessonInfo.trueName }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="9">
                        <el-form-item label="" prop="coverUrl">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/lesson/uploadGrCover'"
                                       :show-file-list="false" :on-success="handleCoverSuccess" :headers="{ token }"
                                       :before-upload="beforeCoverUpload">
                                <img v-if="lessonInfo.coverUrl" :src="lessonInfo.coverUrl" class="avatar" style="position:absolute" />
                                <el-icon v-else class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="评课教师" prop="rateTeacherList">
                            <choosePeople :showTitle="'选择人员'" @gxDisable="gxDisable" ref="rateTeacherList" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="听课教师" prop="listenTeacherList">
                            <choosePeople :showTitle="'选择人员'" @gxDisable="gxDisable" ref="listenTeacherList" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="指导专家" prop="guideExperts">
                            <choosePeople isTsExpertList :showTitle="'选择人员'" ref="guideUsersList" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="评课组长" prop="leadTeacher">
                            <el-select style="width: 100%;" filterable v-model="lessonInfo.leadTeacher" placeholder="请选择评课组长">
                                <el-option v-for="item in leadTeacherList" :key="item.userId" :label="item.trueName"
                                           :value="item.userId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-col :span="12">
                    <el-form-item label="听评量表" prop="scaleIds">
                        <el-select style="width:100%" multiple filterable v-model="lessonInfo.scaleList" placeholder="请选择听评量表">
                            <el-option v-for="item in rateScaleList" :key="item.scaleId" :label="item.title"
                                       :value="item.scaleId">
                                <span style="float: left">{{ item.title }}</span>
                                <span @click.stop="previewScale(item)" style="float: right; color: #8492a6; font-size: 13px">
                                    <el-icon>
                                        <View />
                                    </el-icon></span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-row>
                    <el-col :span="12" v-if="lessonInfo.type === 0">
                        <el-form-item label="听课地址" prop="address">
                            <el-input v-model="lessonInfo.address" placeholder="请使用地图选择听课地址"
                                      maxlength="256">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="" v-show="lessonInfo.type === 0">
                    <aMap v-if="isShowMap"
                          ref="zdyMap1"
                          style="width: 660px"
                          @getGeocoder="getGeocoder"
                          :oldCenter="oldCenter"
                          :isShowAMap="true">
                    </aMap>
                </el-form-item>
            </el-form>
            <div class="disflex-row-center">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>


        <el-dialog title="课程目录" v-model="isDirectory" width="60%">
            <el-row>
                <el-empty v-if="directoryList.length == 0" style="margin: 0 auto;" description="暂无数据" />
                <div style="margin-bottom: 15px;margin-right:40px;" v-for="item in directoryList">
                    <el-card @click="goCourse(item)" class="cursor" style="width: 150px;">
                        <div class="csbbb">
                            <el-image fit="cover" style="width: 130px;height:185px" :src="item.coverUrl"></el-image>
                        </div>
                        <div class="mt5 text-one">{{ item.className }}</div>
                    </el-card>
                </div>
            </el-row>
        </el-dialog>

        <el-dialog title="课程目录" v-model="isCourse" width="60%">
            <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="ptit" label="单元名" width="180">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;">
                            <div @click="changeTitle(scope.row)" :style="scope.row.title ? '' : 'color: #409efe;'"
                                 :class="scope.row.title ? '' : 'cursor'" :title="scope.row.ptit" style="" class="text-one ">
                                {{ scope.row.ptit }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="课程名">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;" v-if="scope.row.id">
                            <div @click="changeTitle(scope.row)" :title="scope.row.title" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog @close="gbIfram" :title="'线上听课'" v-model="isTk" width="80%" top="50px">
            <iframe id="cktpkfx" style="width: 100%;height:calc(100vh - 250px)" :src="lessonInfo.address"
                    frameborder="0"></iframe>
        </el-dialog>

        <el-dialog :title="previewData.title ? previewData.title : '预览'" v-model="previewShow" width="60%">
            <previewData :disabled="disabled" ref="editData" v-if="previewShow" :previewData="previewData" :isHide="isHide">
            </previewData>
            <template #footer v-if="!disabled">
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitPreviewForm">确 定</el-button>
                    <el-button @click="closePreview">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog title="上传本地听课视频" v-model="evaVideoIsDisplay" width="30%">
            <el-upload ref="upload"
                       class="upload-demo"
                       :limit="1"
                       :on-exceed="handleExceed"
                       accept=".mp4,.avi,.flv" :http-request="handleUpload">
                <el-button type="primary">点击上传</el-button>
                <template #tip>
                    <div class="el-upload__tip">
                        只允许上传.mp4,.avi,.flv,格式文件。
                    </div>
                </template>
            </el-upload>
        </el-dialog>

        <el-dialog title="听评课总结"
                   v-model="isShowSum"
                   width="44%"
                   align-center
                   class="sum-info">
            <el-form v-model="summaryForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教学内容" prop="teachContent">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写教学内容方面总结"
                              v-model="summaryForm.teachContent"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教学方法" prop="teachMethod">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写教学方法方面总结"
                              v-model="summaryForm.teachMethod"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课堂氛围" prop="classroomMood">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写课堂氛围方面总结"
                              v-model="summaryForm.classroomMood"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div style="font-weight: bold;margin-bottom: 10px">教师行为</div>
                </el-row>
                <!--                <el-divider content-position="center">教师行为</el-divider>-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="激发兴趣" prop="teaInterest">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写激发兴趣方面总结"
                              v-model="summaryForm.teaInterest"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="达标意识" prop="teaAware">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写达标意识方面总结"
                              v-model="summaryForm.teaAware"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="引导体验" prop="teaExperience">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写引导体验方面总结"
                              v-model="summaryForm.teaExperience"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="评价反馈" prop="teaFeedback">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写评价反馈方面总结"
                              v-model="summaryForm.teaFeedback"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="讲授指导" prop="teaGuide">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写讲授指导方面总结"
                              v-model="summaryForm.teaGuide"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div style="font-weight: bold;margin-bottom: 10px">学生行为</div>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="参与状态" prop="stuStatus">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写参与状态方面总结"
                              v-model="summaryForm.stuStatus"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="参与广度" prop="stuScope">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写参与广度相关总结"
                              v-model="summaryForm.stuScope"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="有效思维" prop="stuThink">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写有效思维方面总结"
                              v-model="summaryForm.stuThink"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合作效果" prop="stuResult">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写合作效果方面总结"
                              v-model="summaryForm.stuResult"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="目标达成" prop="stuAim">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写目标达成方面总结"
                              v-model="summaryForm.stuAim"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="师生关系" prop="teaStuRelation">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写师生关系方面总结"
                              v-model="summaryForm.teaStuRelation"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="其他内容" prop="otherContent">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写其他总结内容"
                              v-model="summaryForm.otherContent"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitSummary">确 定</el-button>
                    <el-button @click="closeSummary">取 消</el-button>
                </div>
            </template>

        </el-dialog>

        <!--听评课量表统计-->
        <el-dialog  v-model="isRateScaleShow" width="640px" :show-close="false">
            <el-descriptions :column="3" :title="'【'+evaLessonTitle+'】量表统计'" border style="margin-top: -15px">
                <template #extra>
                    <el-dropdown v-if="scaleStatsList && scaleStatsList.length > 0" slot="dropdown">
                        <el-tag type="primary" style="height: 24px;border: 1px solid #1f89de;line-height: 24px;color: #1f89de">
                            ⇅ {{scaleTitle}}
                        </el-tag>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item :disabled="scaleId==item.scaleId" v-for="item in scaleStatsList" @click="handleRateScale(item)">{{item.title}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                    <el-tag style="margin-left: 10px" class="homework_tag cursor" @click="this.isRateScaleShow=!this.isRateScaleShow" >关闭</el-tag>
                </template>
            </el-descriptions>
            <el-tabs v-model="activeTabName" @tab-click="handleTabsClick" type="border-card"
                     style="margin-top: -5px">
                <el-tab-pane label="统计结果" name="0" >
                    <div v-if="questionList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                    <div v-for="(item,index) in questionList" :style="index==0?'margin-top:-10px;':''">
                        <h3 style="margin: 10px 0 10px 0;">
                            <span>
                                {{ index + 1 }}.{{item.questionName }}
                            </span>
                            <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                [{{item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容' : '' }}]
                            </span>
                        </h3>
                        <el-table v-if="item.type==1 || item.type==2"
                                  :data="item.answerList"
                                  :row-class-name="hideStat"
                                  border fit>
                            <el-table-column  align="center" label="选项" prop="itemName"/>
                            <el-table-column  align="center" label="小计" prop="answerCount"/>
                            <el-table-column  align="center" label="比例" prop="rate">
                                <template #default="scope">
                                    <div>{{scope.row.rate * 100}}%</div>
                                </template>
                            </el-table-column>
                            <template #append>
                                <div style="display: flex">
                                    <div style="width: 100%;height: 40px;line-height: 40px;font-weight: bold;text-align: center;">
                                        本题有效填写人次：{{item.count}}<span v-if="item.score&&item.score>0">，平均分：{{item.score}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table>
                        <div class="chart-tab" v-if="item.type!=3 && item.type!=4">
                            <ul class="fr">
                                <li @click="handlePieQuestion(item.questionId)" :class="this.pieQuIds.includes(item.questionId)?'liSel':''">
                                    饼状
                                </li>
                                <li @click="handleBarQuestion(item.questionId)" :class="this.barQuIds.includes(item.questionId)?'liSel':''">
                                    柱状
                                </li>
                            </ul>
                        </div>

                        <pieEcharts v-if="item.type!=3 && item.type!=4 && this.pieQuIds.includes(item.questionId)"
                                    :id="item.questionId+'_pie'"
                                    :dataList="item.answerList"/>

                        <barEcharts v-if="item.type!=3 && item.type!=4 && this.barQuIds.includes(item.questionId)"
                                    :id="item.questionId+'_bar'"
                                    :dataList="item.answerList"/>


                        <el-table v-if="item.type==3" :data="item.aveScore" border fit>
                            <el-table-column  align="center" label="打分人数" prop="trueName">
                                <div>{{item.count}}</div>
                            </el-table-column>
                            <el-table-column  align="center" label="平均分" >
                                <template #default="scope">
                                    <div>{{scope.row}}</div>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-table v-if="item.type==4" :data="item.userAnswerList" border fit>
                            <el-table-column  align="center" label="姓名" prop="trueName">
                                <template #default="scope">
                                    <div>{{scope.row.isHide==0?scope.row.trueName:'匿名'}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" label="内容" prop="answerName" />
                        </el-table>

                    </div>
                </el-tab-pane>
                <el-tab-pane label="详细数据" name="1" >
                    <div v-if="userRecordList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                    <div v-if="userRecordList.length!==0" class="stat-data-title">
                        量表提交人数：{{userRecordList.length}}，平均分：{{this.aveScore}}
                    </div>
                    <el-collapse v-if="userRecordList.length!==0" v-model="activeNames" accordion>
                        <el-collapse-item v-for="(item,index) in userRecordList" :name="index+1"
                                          @click.native="handleChange(index)">
                            <template #title>
                                <h3 style="margin: 0 0;" :class="activeIndex==index?'user-record-title active':'user-record-title'">
                                    {{item.isHide==0?(index+1)+'.'+item.trueName:(index+1) +'.匿名'}}
                                    提交时间: {{timestampToTime(item.submitTime)}}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: red;!important;">{{item.totalScore?'总分：'+item.totalScore:''}}</span>
                                </h3>
                            </template>
                            <div v-for="(q,i) in item.questionList">
                                <h3 style="margin: 10px 0 10px 0;color:#909399 ">
                                    <span>
                                        {{ i + 1 }}.{{q.questionName }}
                                    </span>
                                    <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                        [{{q.type == 1 ? '单选' : q.type == 2 ? '多选' : q.type == 3 ? '评分' : q.type == 4 ? '文字内容' : '' }}]
                                    </span>
                                </h3>
                                <div style="margin-left: 10px">
                                    {{q.questionAnswer}}
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <!--课堂实录-->
        <el-dialog title="课堂实录" v-model="isShowLessonVideo" width="35%">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="" prop="videoList">
                        <el-upload ref="upload"
                                   v-model:file-list="videoList"
                                   style="width: 100%"
                                   class="upload-demo"
                                   :auto-upload="true"
                                   :limit="1"
                                   drag
                                   accept=".MP4,.mp4,"
                                   :before-upload="handleBeforeUpload"
                                   :http-request="handleCourseUpload">
                            <div class="el-upload__text">
                                将文件拖拽到此处或<em>点击上传</em>
                            </div>
                            <template #tip>
                                <div class="el-upload__tip">
                                    只允许上传一个MP4格式文件,且大小不超过4G。
                                </div>
                            </template>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitEvaVideo">确定</el-button>
                    <el-button @click="isShowLessonVideo=!isShowLessonVideo">取消</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog @close="closeIframe" :title="'课堂实录'" v-model="isViewVideo"
                   width="80%" top="50px">
            <iframe id="evaVideo" style="width: 100%;height:calc(100vh - 150px)" :src="lessonInfo.lessonVideoUrl"
                    frameborder="0"></iframe>
        </el-dialog>

        <div class="loading-overlay" v-if="loadingVisible">
            <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="8"></el-progress>
            <p class="tips_css">上传中，请等待...</p>
        </div>
    </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { timestampToTime } from "@/utils/date";
import {
    createOrUpdateLessonSummary,
    evaluationInfo, evaluationStop,
    evaLessonVideo,
    evaluationUpdate, infoLessonSummary,
    listEvaDiscuss, rateRecordScore, rateRecordScoreInfo,
    rateScaleInfo,
    rateScaleList,
    submitEvaDiscuss,
} from "@/api/admin/evaluation"
import {downloadFile} from "@/api/adminservice/public";
import {groupListAuthGroup, queryDict} from "@/api/admin/public";
import {serviceUrl, serviceWebUrl} from "@/utils/global"
import {classLibraryListAllBook, classLibraryListTree} from "@/api/admin/classLibrary";
import {orgListSchoolOrg, listUserManagerOrg} from "@/api/admin/system";
import choosePeople from "@/components/choosePeople.vue";
import html2canvas from "html2canvas";
import aMap from "@/components/aMap/index.vue";
import {ElLoading} from "element-plus";
import {getFileNameUUID, signatureUrl} from "@/utils/tools";
import selectLessonFile from "@/components/selectLessonFile.vue";
import previewData from "@/components/previewData.vue";
import barEcharts from "@/components/echart/barEcharts.vue";
import pieEcharts from "@/components/echart/pieEcharts.vue";
import {statsEvaLessonRate} from "@/api/admin/stats";

let OSS = require('ali-oss');
let client = new OSS({
    region: 'oss-cn-beijing',    //创建的时候，bucket所在的区域，华北2->oss-cn-beijing ；其他的可以去百度
    accessKeyId: 'LTAI5tCqpy6gH2Kfn5F7mS7H',// 阿里云控制台创建的AccessKey
    accessKeySecret: 'aVdDcMLLrcWYW5WBePRglyd3oqNIF1', //阿里云控制台创建的AccessSecret
    bucket: 'free-back'  //创建的bucket的名称
})

/*分片大小*/
const SHARD_SIZE_CONFIG = {
    SMALL: 1, // < 200MB
    MEDIUM: 2, // < 1024MB
    LARGE: 5, // < 2048MB
    X_LARGE_RATIO: 500 // >= 2048MB
};

export default {
    name: "teamLessonInfo",
    components: {pieEcharts, barEcharts, selectLessonFile, aMap, choosePeople, vueQr,previewData},
    props:{
        lessonId:{
            type: String,
            default:null,
        },
    },
    watch:{
        lessonId(newValue,oldValue){
            this.queryLessonInfo()
            this.getDisList()
            this.getOrgListTypeOrg()
            this.getRateScaleList();
        },
    },
    data() {
        return {
            isShow:false,
            loading: false,
            isShowMap: false,
            isShowDiscuss: false,
            isTk: false,
            serviceUrl,
            token: this.$storage.get("token"),
            viewMode:'view',
            editMode:'edit',
            showMode:'view',
            timestampToTime,
            lessonInfo:{
                coverUrl: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png',
                groupId: '',
                lessonNature: '1',
                countyId: '',
                schoolId: '',
                type: 0,
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                lessonLevelKey: '',
                title: '',
                lectureTeacher: '',
                rateTeachers: '',
                rateTeacherList: [],
                listenTeacherList: [],
                guideUsersList: [],
                scaleIds: '',
                address: '',
                rateEndTime: '',
                leadTeacher: '',
                guideExperts:'',
                lessonFiles:'',
                lessonFileList:[],
                prepareLessonId:'',
                scaleList:[]
            },
            // 表单校验
            isDirectory: false,
            isCourse: false,
            periodList: [],
            gradeList: [],
            subjectList: [],
            directoryList: [],
            tableData: [],
            lessonLevelList:[],
            currentTime: new Date().getTime(),
            //删除文件
            delFileList: [],
            // 表单校验
            rules: {
                lessonNature: [
                    { required: true, message: "请选择听评课性质", trigger: "change" },
                ],
                groupId: [
                    { required: true, message: "请选择工作室/群组", trigger: "change" },
                ],
                countyId: [
                    { required: true, message: "请选择区县", trigger: "change" },
                ],
                schoolId: [
                    { required: true, message: "请选择学校", trigger: "change" },
                ],
                periodKey: [
                    { required: true, message: "请选择学段", trigger: "change" },
                ],
                rateEndTime: [
                    { required: true, message: "请选择评课截止时间", trigger: "change" },
                ],
                gradeKey: [
                    { required: true, message: "请选择年级", trigger: "change" },
                ],
                subjectKey: [
                    { required: true, message: "请选择学科", trigger: "change" },
                ],
                type: [
                    { required: true, message: "请选择类型", trigger: "change" },
                ],
                title: [
                    { required: true, message: "请输入课程标题", trigger: "blur" },
                ],
                address: [
                    { required: true, message: "请输入听课地址", trigger: "blur" },
                ],
                lectureTeacher: [
                    { required: true, message: "请选择授课教师", trigger: "change" },
                ],
                rateTeacherList: [
                    { required: true, validator: this.checkrateTeacherList },
                ],
                listenTeacherList: [
                    { required: true, validator: this.checklistenTeacherList },
                ],
                formTime: [
                    { required: true, validator: this.checkValidator }
                ],
                coverUrl: [
                    { required: true, validator: this.checkCoverValidator }
                ],
            },
            qrCode: {
                shareTkUrl: '',
                sharePkUrl: '',
                shareZjUrl: '',
                size: 100,
                margin:5,
                logoMargin:5,
            },
            // 量表
            scaleData:{},
            scaleShow:false,
            //评论区
            discussType:1, //研讨内容类型：1-文字 2-图片 3-音频 4-附件
            discussWordContent:'',
            wordContent: '',//文字评论
            imgContent: '',//图片评论
            fileContent: '',//附件评论
            discussList:[],
            // 编辑
            role: this.$storage.get("role"),
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            evaVideoIsDisplay:false,
            leadTeacherList: [],
            userList: [],
            groupList: [],
            natureList: [],
            oldCenter: [],
            countyList: [],
            schoolList: [],
            orgList: [],
            rateScaleList:[],
            fileList: [],
            defaultProps: {
                children: 'groupList',
                label: 'title',
            },
            isShowSum:false, //听评课总结
            summaryForm:{
                lessonId:"",
                teachContent:"",//教学内容
                teachMethod:"",//教学方法
                classroomMood:"",//课堂氛围

                teaInterest:"",//教师行为-激发兴趣
                teaAware:"",//教师行为-达标意识
                teaExperience:"",//教师行为-引导体验
                teaFeedback:"",//教师行为-评价反馈
                teaGuide:"",//教师行为-讲授指导

                stuStatus:"",//学生行为-参与状态
                stuScope:"",//学生行为-参与广度
                stuThink:"",//学生行为-有效思维
                stuResult:"",//学生行为-合作效果
                stuAim:"",//学生行为-目标达成

                teaStuRelation:"",//师生关系
                otherContent:"",//其他内容
            },

            disabled: true,
            isHide: false,
            previewData: {},
            previewShow: false,
            //听评课量表统计
            aveScore:0,
            isRateScaleShow:false,
            activeTabName:'0',
            activeIndex:null,
            activeNames:'',
            scaleId:'',
            scaleTitle:'',
            evaLessonTitle:'', //当前听评课标题
            userRecordList:[], //当前量表填写记录
            questionList:[],  //当前量表问题统计
            scaleStatsList:[], //量表 统计数据
            pieQuIds:'', //饼图问题ID
            barQuIds:'', //柱状图问题ID
            // 课堂实录
            isShowLessonVideo:false,
            evaVideoForm:{
                lessonId:'',
                lessonVideoUrl:'',
            },
            loadingVisible: false,//开启遮罩
            loadingPercentage: 0,
            partItemSize:5,
            isViewVideo:false,
            videoList:[],
        };
    },
    created() {
        this.role = this.$storage.get("role");
        this.getQueryDict()
    },
    mounted() {
        // this.qrCode.shareTkUrl = serviceWebUrl+'/inviteMember?id=' + this.lessonId + '&type=1'
        // this.qrCode.sharePkUrl = serviceWebUrl+'/inviteMember?id=' + this.lessonId + '&type=2'
        // this.qrCode.shareZjUrl = serviceWebUrl+'/inviteMember?id=' + this.lessonId + '&type=6'
        this.qrCode.shareTkUrl = serviceWebUrl+'/inviteListen?lessonId=' + this.lessonId + '&type=1'
        this.qrCode.sharePkUrl = serviceWebUrl+'/inviteListen?lessonId=' + this.lessonId + '&type=2'
        this.qrCode.shareZjUrl = serviceWebUrl+'/inviteListen?lessonId=' + this.lessonId + '&type=3'
        if (this.$storage.get("role") === 6) {
            this.lessonInfo.lectureTeacher = JSON.parse(this.$storage.get("userInfo")).userId;
            this.lessonInfo.trueName = JSON.parse(this.$storage.get("userInfo")).trueName;
        }
        this.queryLessonInfo()
        this.getDisList()
        this.getOrgListTypeOrg()
        this.getRateScaleList();
    },
    computed: {},
    methods: {
        editLesson(){
            // this.queryLessonInfo()
            this.showMode = this.editMode;
        },
        cancel(){
            this.showMode = this.viewMode;
        },
        queryLessonInfo(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
                evaluationInfo({ lessonId: this.lessonId }).then(res => {
                    if (res.data.code===1){
                        // this.changeLessonNature(res.data.data.lessonNature)
                        this.lessonInfo = res.data.data;
                        let endTime = this.lessonInfo.rateEndTime
                        let currentTime = Date.now();
                        if (currentTime<endTime){
                            this.isShowDiscuss = true;
                        }
                        this.$refs.lectureTeacher.checkList = [{ userId: this.lessonInfo.lectureTeacher, trueName: this.lessonInfo.lectureTeacherName }];
                        this.$refs.rateTeacherList.checkList = this.lessonInfo.rateTeacherList;
                        this.$refs.listenTeacherList.checkList = this.lessonInfo.listenTeacherList;
                        this.$refs.lessonFileList.checkFileList = this.lessonInfo.lessonFileList;
                        if (this.lessonInfo.lessonNature === 2 || this.lessonInfo.lessonNature === 3 || this.lessonInfo.lessonNature === 4) {
                            this.$refs.lectureTeacher.getQunPeople(this.lessonInfo.groupId)
                            this.$refs.rateTeacherList.getQunPeople(this.lessonInfo.groupId)
                            this.$refs.listenTeacherList.getQunPeople(this.lessonInfo.groupId)
                        }
                        this.gxDisable();
                        this.$refs.lectureTeacher.disabledList = [...this.$refs.rateTeacherList.checkList, ...this.$refs.listenTeacherList.checkList]
                        this.$refs.rateTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.listenTeacherList.checkList]
                        this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
                        this.fileList=[]
                        this.lessonInfo.fileList.forEach(e => {
                            this.fileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.videoList = [];
                        if (this.lessonInfo.lessonVideoUrl){
                            this.evaVideoForm.lessonVideoUrl = this.lessonInfo.lessonVideoUrl
                            this.videoList.push({
                                name: '课堂实录',
                                fileId: this.lessonInfo.lessonId,
                                url: this.lessonInfo.lessonVideoUrl,
                                response: {
                                    data: this.lessonInfo.lessonVideoUrl
                                }
                            })
                        }

                        const rateTeacherTxt = [];
                        this.lessonInfo.rateTeacherList.forEach(e => {
                            rateTeacherTxt.push(e.trueName)
                        })
                        this.lessonInfo.rateTeacherTxt = rateTeacherTxt.join('、')

                        const listenTeacherTxt = [];
                        this.lessonInfo.listenTeacherList.forEach(e => {
                            listenTeacherTxt.push(e.trueName)
                        })
                        this.lessonInfo.listenTeacherTxt = listenTeacherTxt.join('、')

                        const guideExpertTxt = [];
                        this.lessonInfo.guideExpertList.forEach(e => {
                            guideExpertTxt.push(e.trueName)
                        })
                        this.lessonInfo.guideExpertTxt = guideExpertTxt.join('、')
                        this.periodList.forEach(j => {
                            if (this.lessonInfo.periodKey === j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                        this.periodList.forEach(e => {
                            if (this.lessonInfo.periodKey === e.dictKey) {
                                e.childrenList.forEach(j => {
                                    if (this.lessonInfo.gradeKey === j.dictKey) {
                                        this.subjectList = j.childrenList;
                                    }
                                })
                            }
                        })
                        orgListSchoolOrg({ orgId: this.lessonInfo.countyId }).then(res => {
                            this.schoolList = res.data.data;
                        })
                        // 地图
                        if (this.lessonInfo.type === 0) {
                            this.oldCenter = [this.lessonInfo.lng, this.lessonInfo.lat]
                        }
                        this.isShowMap = true
                        if (this.lessonInfo.type === 0) {
                            setTimeout(() => {
                                this.$refs.zdyMap.center = this.oldCenter;
                                this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                                this.$refs.zdyMap1.center = this.oldCenter;
                                this.$refs.zdyMap1.componentMarker.position = this.oldCenter;
                            }, 100)
                        }
                        this.showMode = this.viewMode;
                        this.isShow = true;
                    }
                })
            })
        },
        viewFile(file){},
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {

            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'topic_level' }).then(res => {
                this.lessonLevelList = res.data.data;
            })
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data;
            })
        },
        changePeriod() {
            this.lessonInfo.gradeKey = '';
            this.lessonInfo.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.lessonInfo.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.lessonInfo.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.lessonInfo.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.lessonInfo.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeCoverUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        queryDirectory() {
            classLibraryListAllBook().then(res => {
                if (this.lessonInfo.periodKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.periodKey == this.lessonInfo.periodKey
                    })
                }
                if (this.lessonInfo.gradeKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.gradeKey == this.lessonInfo.gradeKey
                    })
                }
                if (this.lessonInfo.subjectKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.subjectKey == this.lessonInfo.subjectKey
                    })
                }
                this.directoryList = JSON.parse(JSON.stringify(res.data.data));
                this.isDirectory = true;
            });
        },
        goCourse(item) {
            this.tableData = []
            classLibraryListTree().then(res => {
                res.data.data.forEach(e => {
                    if (item.classId == e.classId) {
                        if (e.childrenList) {
                            e.childrenList.forEach(j => {
                                if (j.childrenList) {
                                    j.childrenList.forEach((m, n) => {
                                        if (n == 0) {
                                            this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: j.childrenList.length, className: e.className })
                                        } else {
                                            this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: 0, className: e.className })
                                        }
                                    })
                                } else {
                                    this.tableData.push({ pid: j.classId, ptit: j.className, id: '', title: '', col: 1, className: e.className })
                                }
                            })
                        }
                    }
                })
                this.isCourse = true
            })
        },
        changeTitle(row) {
            this.lessonInfo.title = row.className + '­—' + row.ptit + (row.title ? '­—' + row.title : '')
            this.isDirectory = false;
            this.isCourse = false;
        },
        objectSpanMethod(e) {
            // console.log(e);
            if (e.columnIndex === 0) {
                if (e.row.col != 0) {
                    return {
                        rowspan: e.row.col,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },
        handleXTChange(file) {},
        handleJAChange(file) {},
        handleXAChange(file) {},
        handleKjChange(file) {},
        beforeJAUpload(rawFile) {
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        handleRemove(file, uploadFiles) {
            if (file.response.data) {
                this.delFileList.push(file.response.data)
            }
        },
        checkrateTeacherList(rule, value, callback) {
            if (this.$refs.rateTeacherList.checkList.length === 0) {
                callback(new Error('请选择评课教师'))
            } else {
                callback()
            }
        },
        checklistenTeacherList(rule, value, callback) {
            if (this.$refs.listenTeacherList.checkList.length === 0) {
                callback(new Error('请选择听课教师'))
            } else {
                callback()
            }
        },
        submitForm() {
            this.lessonInfo.beginTime = this.setHms(this.lessonInfo.beginTime);
            this.lessonInfo.endTime = this.setHms(this.lessonInfo.endTime);
            this.lessonInfo.rateEndTime = this.setHms(this.lessonInfo.rateEndTime);
            //授课教师
            if (this.$refs.lectureTeacher.checkList.length !== 0) {
                this.lessonInfo.lectureTeacher = this.$refs.lectureTeacher.checkList[0].userId;
            } else {
                this.lessonInfo.lectureTeacher = '';
            }
            if (this.role === 6) {
                this.lessonInfo.lectureTeacher = JSON.parse(this.$storage.get("userInfo")).userId;
            }
            //评课教师
            this.lessonInfo.rateTeacherList = [];
            this.$refs.rateTeacherList.checkList.forEach(e => {
                this.lessonInfo.rateTeacherList.push(e.userId)
            })
            this.lessonInfo.rateTeachers = this.lessonInfo.rateTeacherList.toString()
            //听课教师
            this.lessonInfo.listenTeacherList = [];
            this.$refs.listenTeacherList.checkList.forEach(e => {
                this.lessonInfo.listenTeacherList.push(e.userId)
            })
            this.lessonInfo.listenTeachers = this.lessonInfo.listenTeacherList.toString()
            //指导专家
            this.lessonInfo.guideUsersList = [];
            this.$refs.guideUsersList.checkList.forEach(e => {
                this.lessonInfo.guideUsersList.push(e.userId)
            })
            this.lessonInfo.guideExperts = this.lessonInfo.guideUsersList.toString()
            //协同备课文件
            this.lessonInfo.lessonFileList = [];
            this.$refs.lessonFileList.checkFileList.forEach(e =>{
                this.lessonInfo.lessonFileList.push(e.fileId)
            })
            this.lessonInfo.lessonFiles = this.lessonInfo.lessonFileList.toString()

            this.lessonInfo.prepareLessonId = this.$refs.lessonFileList.lessonId;

            const fileList = [];
            this.fileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            console.log("开始校验")
            this.$refs["form"].validate(valid => {
                if (valid) {
                    console.log("通过校验")
                    var obj = JSON.parse(JSON.stringify(this.lessonInfo));
                    obj.fileUrls = fileList.toString();
                    if (obj.type === 1) {
                        obj.lat = ''
                        obj.lng = ''
                    }
                    obj.scaleIds = obj.scaleList.toString();
                    delete obj.rateTeacherList
                    evaluationUpdate(obj).then(res => {
                        if (res.data.code === 1) {
                            this.queryLessonInfo()
                            this.$message.success("操作成功");
                        } else {
                            this.$message.error("操作失败")
                        }
                    });
                }
            });
        },
        handleGAJaChange(e, type) {
            if (e.response) {
                if (e.response.code == 1) {
                    let arr = []
                    this.lessonInfo.gajaFiles.forEach(j => {
                        var fileUrl = ''
                        if (j.url) {
                            fileUrl = j.url
                        } else {
                            fileUrl = j.response.data
                        }
                        if (fileUrl != e.response.data) {
                            arr.push(new Promise(function (resolve, reject) {
                                delLessonFile({ fileUrl: fileUrl }).then(res => {
                                    resolve(res.data.code)
                                })
                            }))
                        }
                    })
                    Promise.all(arr).then((result) => {
                        this.queryLessonInfo()
                    })

                } else {

                }
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        changeLessonNature(e) {
            this.groupList = [];
            this.lessonInfo.groupId = '';
            if (e == 1) {
                // this.sxKj()
                // this.$refs.lectureTeacher.getUserList()
                // this.$refs.rateTeacherList.getUserList()
                // this.$refs.listenTeacherList.getUserList()
            } else if (e == 2) {
                groupListAuthGroup({ groupNature: 2 }).then(res => {
                    this.groupList = res.data.data;
                })
                // this.sxKj()
                // this.$refs.lectureTeacher.getUserList()
                // this.$refs.rateTeacherList.getUserList()
                // this.$refs.listenTeacherList.getUserList()
            } else if (e == 3) {
                groupListAuthGroup({ groupNature: 3 }).then(res => {
                    this.groupList = res.data.data;
                })
                // this.sxKj()
                // this.$refs.lectureTeacher.getUserList()
                // this.$refs.rateTeacherList.getUserList()
                // this.$refs.listenTeacherList.getUserList()
            } else if (e == 4) {
                // this.sxKj()
                groupListAuthGroup({ groupNature: 1 }).then(res => {
                    this.groupList = res.data.data;
                })
            }
        },
        changeQun() {
            this.sxKj()
            this.$refs.lectureTeacher.getQunPeople(this.lessonInfo.groupId)
            this.$refs.rateTeacherList.getQunPeople(this.lessonInfo.groupId)
            this.$refs.listenTeacherList.getQunPeople(this.lessonInfo.groupId)
        },
        handleTkDownload() {
            html2canvas(this.$refs.tkcode.$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300
            }).then(async canvas => {
                // 生成图片地址
                const imgUrl = canvas.toDataURL('image/png');
                const eleLink = document.createElement('a');
                eleLink.href = imgUrl;
                eleLink.download = this.lessonInfo.title + '-听课邀请码.png';
                // // 下载
                eleLink.click();
            })
        },
        handlePkDownload() {
            html2canvas(this.$refs.pkcode.$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300
            }).then(async canvas => {
                const imgUrl = canvas.toDataURL('image/png');
                const eleLink = document.createElement('a');
                eleLink.href = imgUrl;
                eleLink.download = this.lessonInfo.title + '-评课邀请码.png';
                eleLink.click();
            })
        },
        handleZjDownload() {
            html2canvas(this.$refs.zjcode.$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300
            }).then(async canvas => {
                const imgUrl = canvas.toDataURL('image/png');
                const eleLink = document.createElement('a');
                eleLink.href = imgUrl;
                eleLink.download = this.lessonInfo.title + '-专家邀请码.png';
                eleLink.click();
            })
        },
        getGeocoder(e) {
            if (this.lessonInfo.type === 0) {
                this.lessonInfo.lat = e.center[1];
                this.lessonInfo.lng = e.center[0];
                this.lessonInfo.address = e.formattedAddress;
            }

        },
        beginLesson(){
            if (this.lessonInfo.type === 1){
                this.viewZhiBo();
            }else {
                this.goTk();
            }
        },
        viewZhiBo(){
            var newDate = new Date().getTime();
            if (newDate > this.lessonInfo.beginTime && newDate < this.lessonInfo.endTime) {
                window.open(this.lessonInfo.address, '_blank')
            } else {
                this.$message.error('已过/未到任务时段中')
            }
        },
        goTk() {
            var newDate = new Date().getTime();
            if (newDate > this.lessonInfo.beginTime && newDate < this.lessonInfo.endTime) {
                this.isTk = true;
                setTimeout(() => {
                    var iframe = document.getElementById("cktpkfx"); // 获取到要关闭的iframe元素
                    iframe.setAttribute("src", this.lessonInfo.address);
                })
            } else {
                this.$message.error('已过/未到任务时段中')
            }
        },
        gbIfram() {
            const iframe = document.getElementById("cktpkfx"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
        // 预览量表
        previewScale(item) {
            rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                this.scaleData = res.data.data;
                this.scaleShow = true;
            })
        },
        // 评论区
        handleUploadImageSuccess(response, uploadFile){
            if (uploadFile.response.code === 1) {
                this.imgContent = uploadFile.response.data;
                this.discussType = 2
                this.submitDiscuss()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeImageUpload(rawFile){
            if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleUploadFileSuccess(response, uploadFile){
            if (uploadFile.response.code === 1) {
                this.fileContent = uploadFile.response.data;
                this.discussType = 4
                this.submitDiscuss()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeFileUpload(rawFile){
            return true
        },
        focusInput(){
            this.closeInput = false
        },
        handleUnKnow(){
            this.$message.info("该文件类型暂不支持预览")
        },
        comStr(baseStr,type){
            return type!==''&& type.toUpperCase().includes(baseStr.toUpperCase());
        },
        getDisList() {
            listEvaDiscuss({ lessonId: this.lessonId }).then(res => {
                this.discussList = res.data.data;
            })
        },
        submitDiscuss(){

            const obj = {
                lessonId: this.lessonId,
                content: this.wordContent,
                imgContent: this.imgContent,
                fileContent: this.fileContent,
            };
            //文字评论
            if (this.discussType===1){
                this.wordContent = this.discussWordContent
                if (this.wordContent===''){
                    this.$message.info("讨论内容不能为空")
                    return
                }
                obj.content=this.wordContent;
                obj.imgContent = '';
                obj.fileContent = ''
            }
            //图片评论
            if (this.discussType===2){
                if (this.imgContent===''){
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content='';
                obj.imgContent = this.imgContent;
                obj.fileContent = ''
            }
            //附件评论
            if (this.discussType===4){
                if (this.fileContent===''){
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content='';
                obj.imgContent = '';
                obj.fileContent = this.fileContent
            }
            const loading = ElLoading.service({ fullscreen: true })
            submitEvaDiscuss(obj).then(res =>{
                if (res.data.code === 1) {
                    this.$message.success("发表成功");
                    this.wordContent = ''
                    this.discussWordContent = ''
                    this.imgContent = ''
                    this.fileContent = ''
                    this.discussType = 1
                    this.getDisList();
                    loading.close();
                } else {
                    this.$message.error(res.data.msg)
                    this.discussType = 1
                    loading.close();
                }
            })

        },
        sxKj() {
            this.$refs.lectureTeacher.checkList = []
            this.$refs.rateTeacherList.checkList = []
            this.$refs.listenTeacherList.checkList = []
            this.$refs.lectureTeacher.disabledList = []
            this.$refs.rateTeacherList.disabledList = []
            this.$refs.listenTeacherList.disabledList = []
        },
        getOrgListTypeOrg() {
            listUserManagerOrg().then(res => {
                this.countyList = res.data.data;
            })
        },
        changeCounty() {
            this.lessonInfo.schoolId = '';
            this.schoolList = [];
            orgListSchoolOrg({ orgId: this.lessonInfo.countyId }).then(res => {
                this.schoolList = res.data.data;
            })
        },
        getRateScaleList() {
            rateScaleList({ scaleType: 1 }).then(res => {
                this.rateScaleList = res.data.data;
            })
        },
        startDateConfirm(e) {
            if (e >= this.lessonInfo.endTime) {
                this.lessonInfo.endTime = '';
            }
        },
        endDateConfirm(e) {
            if (e <= this.lessonInfo.beginTime) {
                this.lessonInfo.beginTime = '';
            }
        },
        checkValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.lessonInfo.beginTime === '' || !this.lessonInfo.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (this.lessonInfo.endTime === '' || !this.lessonInfo.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.lessonInfo.beginTime) {
                return current && current < this.lessonInfo.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        showUpload(){
            this.evaVideoIsDisplay = true;
        },
        handleExceed(){},
        handleUpload(option){
            const loading = ElLoading.service({ fullscreen: true })
            var obj = option.file.name
            const index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + this.getFileName(option.file.name)
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/user-video/${objName}`, option.file).then(res => {
                signatureUrl(`/ygjy/user-video/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                        this.lessonInfo.address = result;
                        loading.close()
                        this.evaVideoIsDisplay = false;
                    } else {
                        loading.close()
                    }
                })
            })
        },
        lessonTeamUser(userList){
            this.$refs.listenTeacherList.checkList = userList;
            this.gxDisable();
            this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
        },
        gxDisable() {
            this.$refs.lectureTeacher.disabledList = [...this.$refs.rateTeacherList.checkList, ...this.$refs.listenTeacherList.checkList]
            this.$refs.rateTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.listenTeacherList.checkList]
            this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
            this.$refs.guideUsersList.disabledList = [...this.$refs.lectureTeacher.checkList]
            this.leadTeacherList = [];
            this.$refs.rateTeacherList.checkList.forEach(e => {
                this.leadTeacherList.push(e)
            })
            const rateCheckList = []
            this.$refs.rateTeacherList.checkList.forEach(e => {
                rateCheckList.push(e.userId)
            })
            if (rateCheckList.indexOf(this.lessonInfo.leadTeacher) === -1) {
                this.lessonInfo.leadTeacher = ''
            }
            this.$forceUpdate()
        },
        handleStop() {
            evaluationStop({ lessonId: this.lessonId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo();
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleSummary(){
            this.isShowSum = true;
            infoLessonSummary({ lessonId: this.lessonId }).then(res => {
                if (res.data.code === 1) {
                    this.summaryForm = res.data.data;
                    this.isShowSum = true;
                }else {
                    this.summaryForm.lessonId = this.lessonId;
                }
            })
        },
        closeSummary(){
            this.isShowSum = false;
        },
        submitSummary(){
            if (this.summaryForm.teachContent===null
              &&this.summaryForm.teachMethod===null
              &&this.summaryForm.classroomMood===null

              &&this.summaryForm.teaInterest===null
              &&this.summaryForm.teaAware===null
              &&this.summaryForm.teaExperience===null
              &&this.summaryForm.teaFeedback===null
              &&this.summaryForm.teaGuide===null

              &&this.summaryForm.stuStatus===null
              &&this.summaryForm.stuScope===null
              &&this.summaryForm.stuThink===null
              &&this.summaryForm.stuResult===null
              &&this.summaryForm.stuAim===null

              &&this.summaryForm.teaStuRelation===null
              &&this.summaryForm.otherContent===null){
                this.$message.info("总结内容至少须填写一项")
                return
            }

            this.summaryForm.lessonId = this.lessonId;
            createOrUpdateLessonSummary(this.summaryForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.isShowSum = false;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        handleComplete(item) {
            if(this.lessonInfo.role===3||this.lessonInfo.role===1||this.lessonInfo.role===0){
                this.disabled = false;
            }
            console.log(this.disabled)
            this.isHide = false;
            if (item.isSub == 1) {
                rateRecordScoreInfo({ lessonId: this.lessonId, scaleId: item.scaleId }).then(res => {
                    if (res.data.data.info.isHide == 1) {
                        this.isHide = true;
                    }
                    this.previewData = res.data.data.info;
                    this.previewData.questionList.forEach(e => {
                        if (e.type == 2) {
                            e.questionAnswer = e.questionAnswer.split(',');
                        } else {
                            // e.questionAnswer = '';
                        }
                    })
                    this.previewShow = true;
                })
            } else {
                rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                    this.previewData = res.data.data;
                    this.previewData.questionList.forEach(e => {
                        if (e.type == 2) {
                            e.questionAnswer = [];
                        } else {
                            e.questionAnswer = '';
                        }

                    })
                    this.previewShow = true;
                })
            }
        },
        submitPreviewForm() {
            var obj = {};
            obj.scaleId = this.$refs.editData.previewData.scaleId;
            obj.lessonId = this.lessonId;
            obj.answerList = [];
            if (this.$refs.editData.isHide) {
                obj.isHide = 1;
            } else {
                obj.isHide = 0;
            }
            var totalScore = 0;
            this.$refs.editData.previewData.questionList.forEach(e => {
                if (e.type == 2) {
                    var txt = e.questionAnswer.toString()
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: txt
                    })
                    e.questionAnswer.forEach(m=>{
                        e.itemList.forEach(j=>{
                            if(m == j.itemId){
                                totalScore += Number(j.itemValue)
                            }
                        })
                    })
                } else {
                    if(e.type == 1){
                        e.itemList.forEach(j=>{
                            if(e.questionAnswer == j.itemId){
                                totalScore += Number(j.itemValue)
                            }
                        })
                    }
                    if(e.type == 3){
                        totalScore += Number(e.questionAnswer)
                    }
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: e.questionAnswer
                    })
                }

            })
            obj.totalScore = totalScore;
            rateRecordScore(obj).then(res => {
                if (res.data.code == 1) {
                    this.previewShow = false;
                    this.isHide = false;
                    this.$message.success('提交成功')
                    this.queryLessonInfo();
                } else {
                    this.$message.error(res.data.msg)
                }
            })

        },
        closePreview() {
            this.previewShow = false;
        },
        // 听评课量表统计
        handleRateScale(item){
            const sId = item.scaleId;
            this.evaLessonTitle = this.lessonInfo.title;
            this.isRateScaleShow = true;
            this.activeIndex = null
            this.userRecordList = []
            this.questionList = []
            this.pieQuIds = ''
            this.barQuIds = ''
            statsEvaLessonRate({lessonId:this.lessonId}).then(res => {
                if (res.data.code === 1){
                    this.scaleStatsList = res.data.data;
                    this.scaleStatsList.forEach(e => {
                        if (sId===e.scaleId){
                            this.scaleId = e.scaleId;
                            this.scaleTitle = e.title;
                            this.userRecordList = e.userRecordList;
                            this.questionList = e.questionList;
                            this.aveScore = e.score
                            this.pieQuIds = ''
                            this.barQuIds = ''
                            this.questionList.forEach(q  => {
                                this.pieQuIds = this.pieQuIds+q.questionId
                            })
                        }
                    })
                    this.isRateScaleShow = true;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleTabsClick(item){
            this.activeTab = item.name;
        },
        changeScale(item){
            this.scaleId = item.scaleId;
            this.scaleTitle = item.title;
            this.userRecordList = item.userRecordList;
            this.questionList = item.questionList;
            this.pieQuIds = ''
            this.barQuIds = ''
            this.questionList.forEach(q  => {
                this.pieQuIds = this.pieQuIds+q.questionId
            })
            console.log("饼图显示："+this.pieQuIds)
        },
        handlePieQuestion(qId){
            if (!this.pieQuIds.includes(qId)){
                this.pieQuIds = this.pieQuIds+qId;
            }
            if (this.barQuIds.includes(qId)){
                this.barQuIds = this.barQuIds.replace(qId,'');
            }
        },
        handleBarQuestion(qId){
            if (!this.barQuIds.includes(qId)){
                this.barQuIds = this.barQuIds +qId;
            }
            if (this.pieQuIds.includes(qId)){
                this.pieQuIds = this.pieQuIds.replace(qId,'');
            }
        },
        handleChange(index){
            this.activeIndex = index
        },
        hideStat({ row, rowIndex }){
            if (row.answerCount===0){
                // return 'hidden-row'
                return '';
            }
            return '';
        },
        // 课堂实录
        submitEvaVideo(){
            if (!this.evaVideoForm.lessonVideoUrl){
                this.$message.info("请上传课堂实录")
                return
            }
            this.evaVideoForm.lessonId = this.lessonId;
            evaLessonVideo(this.evaVideoForm).then(res => {
                if (res.data.code === 1) {
                    this.queryLessonInfo();
                    this.isShowLessonVideo = false;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        handleBeforeUpload(rawFile){
            console.log("视频大小："+rawFile.size)
            if (!(rawFile.type === 'video/mp4')) {
                this.$message.error('不支持此类型文件')
                return false
            } else if (rawFile.size / 1024/1024/1024 > 4) {
                this.$message.error('文件大小不能超过4G')
                return false
            }
            let fs = rawFile.size / 1024/1024;
            this.partItemSize = this.calcShardSize(fs);
            console.log("动态分片大小："+this.partItemSize);
            return true
        },
        calcShardSize(fileSize) {
            if (fileSize < 200) return SHARD_SIZE_CONFIG.SMALL;   // 1MB
            else if (fileSize < 1024) return SHARD_SIZE_CONFIG.MEDIUM; // 2MB
            else if (fileSize < 2048) return SHARD_SIZE_CONFIG.LARGE;  // 5MB
            else return Math.ceil(fileSize / SHARD_SIZE_CONFIG.X_LARGE_RATIO); // 动态分片
        },
        handleCourseUpload(option) {
            // 文件后缀
            var fileType = this.getFileName(option.file.name);
            // 获取文件的后缀名
            var obj = option.file.name
            var index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + fileType
            this.loadingVisible = true;
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/evaVideo/${objName}`, option.file).then(res => {
                this.loadingVisible = false;
                // 上传成功之后，转换真实的地址
                signatureUrl(`/ygjy/evaVideo/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.evaVideoForm.lessonVideoUrl = result;
                    this.loadingVisible = false;
                })
            })
        },
        async multipartUpload(ObjName, fileUrl) {
            try {
                let result = await client.multipartUpload(`${ObjName}`, fileUrl, {// 获取分片上传进度、断点和返回值。
                    progress: (p, cpt, res) => {
                        console.log(p);
                        this.loadingPercentage = parseInt(p * 100);
                    },
                    timeout: 600000000,
                    // 设置并发上传的分片数量。
                    parallel: 6,
                    // 设置分片大小。默认值为1 MB，最小值为100 KB。
                    partSize: 1024 * 1024 * this.partItemSize,
                })
                // ObjName为文件名字,可以只写名字，就直接储存在 bucket 的根路径，如需放在文件夹下面直接在文件名前面加上文件夹名称
                return result
            } catch (e) {
                this.$message.error('上传失败')
            }
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));
        },
        viewVideo() {
            this.isViewVideo = true;
            setTimeout(() => {
                var iframe = document.getElementById("evaVideo"); // 获取到要关闭的iframe元素
                iframe.setAttribute("src", this.lessonInfo.lessonVideoUrl);
            })

        },
        closeIframe() {
            const iframe = document.getElementById("evaVideo"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
    }
};
</script>
<style scoped>
.el-icon .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 152px;
    text-align: center;
}
.course-container{
    width: 100%;
    height: auto;
}
.lesson-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.lesson-edit-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.left-container{
    width: calc(100% - 270px);
    height: auto;
    background-color: #fff;
    padding-left: 10px;
    box-sizing: border-box;
    padding-bottom: 10px;
    padding-right: 10px;
}
.right-container{
    width: 260px;
    height: auto;
    margin-left: 10px;
    background-color: #fff;
}
.top-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    font-weight: bold;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #0d55a4;
}
.flex-item:last-child{
    margin-left: auto;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #0d55a4;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.column-status{
    width: 60px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}
.column-status-fb{
    width: 60px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}
.column-btn{
    //padding-right: 10px;
    display: flex;
}
.btn{
    width: auto;
    height: 20px;
    border: 1px solid #0d55a4;
    color: #0d55a4;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;
    padding-left: 5px;
    padding-right: 5px;
}
.base-info-container{
    //display: flex;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    padding-top: 10px;
}

.info-lesson-title{
    width: 100%;
    height: 45px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-sizing: border-box;

}
.base-info-cover{
    width: 240px;
    height: 160px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}

.part-container{
    width: 100%;
    height: auto;
    display: flex;
}
.map-container{
    width: 96%;
    height: auto;
    margin: auto;
    padding-top: 10px;
    padding-bottom: 10px;
}
.part1-l{
    width: calc(100% - 240px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.part1-r{
    width: 240px;
    height: 100%;
}
.part2-l{
    width: 50%;
    height: 100%;
}
.part2-r{
    width: 50%;
    height: 100%;
    display: flex;
}
.code-item{
    width: 120px;
    height: 120px;
    padding-right: 20px;
}
.code-title{
    width: 100%;
    height: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
}
.code-img{
    cursor: pointer;
}
.info-item{
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    div{
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 14px;
}

.eva-btn{
    //padding-left: 10px;
    //padding-right: 10px;
    width: 68px!important;
    background-color: #0d55a4;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
}
.file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
/*讨论区*/
.discuss-title-box{
    height: 20px;
    line-height: 20px;
    background-color: rgba(255,255,255,.9);
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #0d55a4;
    font-size: 16px;
    text-indent: 5px;
    margin-left: 10px;
    margin-top: 10px;
}
.discuss-uploader{
    width: 26px;
    height: 26px;
}

.discuss-sub-box{
    width: 100%;
    background-color: rgba(255,255,255,.9);
    //border-radius: 8px;
    padding: 10px 10px 0 8px;
    box-sizing: border-box;
    height: 100px;
    //border-bottom: 1px solid #0d55a4;
    .discuss-info{
        display: inline-block;
        width: 250px;
        >>>.el-textarea__inner::placeholder{
            font-size: 12px;
        }
        >>>.el-textarea__inner{
            font-size: 12px;
        }
    }

    .discuss-btn-box{
        display: flex;
        padding: 0 6px;
        margin-top: 10px;
        .el-button--primary{
            width: 56px;
            height: 26px;
            font-size: 12px;
            line-height: 30px!important;
            text-align: center;
            &:hover{
                background-color: #0d55a4;
            }
        }
        .limit{
            width: 26px;
            height: 26px;
            background-color: #0d55a4;
            font-size: 12px;
            color: #999aaa;
            border-radius: 13px;
            margin-right: 10px;
            .icon-upload-img{
                width: 20px;
                height: 20px;
                margin: 3px 0 0 3px;
            }
        }
    }
}

.discuss-show-box{
    width: 260px!important;
    margin: auto;
    height: calc(100vh - 280px)!important;
    padding: 10px 0 0 0;
    background-color: rgba(255,255,255,.9);
}
/deep/ .el-scrollbar__thumb {
    //background-color: #ec623e;
}
/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}
.discuss-one{
    display: flex;
    padding-bottom: 10px;
    padding-left: 5px;
    background-color: rgba(255,255,255,.9);
    .discuss-user-avatar{
        width: 40px;

    }
    .discuss-user-avatar-img{
        width: 30px!important;
        height: 30px;
        border-radius: 15px!important;
    }
    .discuss-user-content{
        width: 220px;
        font-size: 14px;
        .user-info{
            display: flex;
            height: 25px;
            padding-right: 10px;
            .flex-item:last-child{
                margin-left: auto;
            }
            .user-true-name{
                font-size: 12px;
                //font-weight: bold;
                //width: 40px;
                height: 25px;
                line-height: 25px;
                text-align: left;
                margin-right: 10px;
                align-content: flex-start;
            }
            .user-role{
                font-size: 10px;
                div{
                    text-align: center;
                }
            }
            .content-time{
                line-height: 25px;
                font-size: 12px;
                align-content: flex-end;
            }
        }
        .content-info{
            padding: 2px 10px 0 0;
            font-size: 11px;
            color: #525B68;
            line-height: 16px;
            word-wrap:break-word;
            word-break:break-all;

        }
        .img-info{
            padding: 2px 10px 0 0;
            display: flex;
            width: 180px;
            flex-wrap: wrap;
            .el-image{
                width: 120px;
                height: auto;
                margin: 0 5px 5px 0;
            }
        }
        .audio-info{
            padding: 2px 10px 0 0;
            audio{
                width: 210px;
                height: 40px;
            }
        }
        .file-info{
            padding: 2px 10px 0 0;
            .file-box{
                width: 210px;
                height: 44px;
                background-color: #f1f3f4;
                border-radius: 5px;
                display: flex;
                .file-icon{
                    width: 40px;
                    height: 40px;
                    img{
                        width: 24px;
                        height: 30px;
                        margin-top: 6px;
                        margin-left: 6px;
                    }
                    .icon-image{
                        width: 24px;
                        height: 30px;
                        margin-top: 6px;
                        margin-left: 6px;
                    }
                }
                .file-detail{
                    width: 160px;
                    height: 40px;
                    padding: 2px 0 2px 0;
                    div{
                        width: 160px;
                        height: 20px;
                    }
                    .name-box{
                        line-height: 24px;
                        font-size: 10px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        cursor: pointer;
                        &:hover{
                            color: #0d55a4;
                        }
                    }
                    .size-box{
                        display: flex;
                        font-size: 10px;
                        line-height: 20px;
                        .file-view{
                            width: 15px;
                            height: 15px;
                            //background-color: #0d55a4;
                            border-radius: 5px;
                            margin-top: 5px;
                            img{
                                width: 13px;
                                height: 13px;
                                margin: 1px 0 0 0;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

    }
}
.role1{
    padding: 1px 4px 1px 4px;
    background-color: #0d55a4;
    margin-top: 4px;
    border-radius: 4px;
    color: #FFFFFF;
    text-align: center;
}
.role2{
    padding: 1px 4px 1px 4px;
    background-color: #f1f1f1;
    margin-top: 4px;
    border-radius: 4px;
    color: #666666;
    text-align: center;
}
.role3{
    padding: 1px 4px 1px 4px;
    background-color: #f1a792;
    margin-top: 4px;
    border-radius: 4px;
    color: #0d55a4;
}
.eva-btn{
    height: 26px!important;
    width: 60px!important;
    font-size: 12px;
    >>>.el-button--primary{
        font-size: 12px;
        text-align: center;
    }
}

/*编辑*/
.scale-item{
    display: flex;
    cursor: pointer;
}

.chart-tab{
    display: flex;
    text-align: center;
    margin: 5px 0;
    color: #333;
    //float: right;
}
.chart-tab ul{
    background: #ebebeb;
    padding: 0 2px;
    list-style: none;
    border: none;
    margin: 0;
    display: block;
}

.chart-tab ul li{
    float: left;
    height: 28px;
    line-height: 26px;
    text-align: center;
    background: #fff;
    border-radius: 2px;
    margin: 2px 1px;
    cursor: pointer;
    padding: 0 4px
}

.fr{
    float: right;
}
.liSel{
    color: #0d55a4;
}



.avatar-uploader .avatar {
    width: 240px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    width: 240px;
    height: 152px;
    //border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.loading-overlay {
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

::v-deep .el-progress__text {
    font-size: 24px !important;
    color: rgb(30, 160, 225) !important;
}

::v-deep .el-progress-circle {
    width: 150px !important;
    height: 150px !important;
}

.tips_css {
    font-size: 20px;
    color: rgb(30, 160, 225)
}


.stat-data-title{
    height: 30px;
    font-size: 15px;
    color: #0d55a4;
    font-weight: bold;
}
</style>

